import { useUntitledUITheme } from '@trm/ui-kit-admin/v7/hooks';
import { Outlet } from 'react-router-dom';
// project import
import GuestGuard from '~/utils/route-guard/GuestGuard';

// ==============================|| LAYOUT - AUTH ||============================== //

const AuthLayout = () => {
  useUntitledUITheme('dark');

  return (
    <GuestGuard>
      <Outlet />
    </GuestGuard>
  );
};

export default AuthLayout;
